import * as React from 'react'
import ReactDOM from 'react-dom'
import { observer, Provider } from 'mobx-react'
import { StateModel } from '../state'
import { TabCircles } from './TabCircles'
import { Challenge } from '../../../lib/constants'

interface Props {
  challenge: Challenge
  showChallengeSwitcher?: boolean
}

@observer
export class Circles extends React.Component<Props> {
  state = StateModel.create({})

  static defaultProps = {
    showChallengeSwitcher: false,
  }

  componentDidMount() {
    this.state.Circles.setChallenge(this.props.challenge)
  }

  render() {
    return (
      <Provider state={this.state}>
        <TabCircles showChallengeSwitcher={this.props.showChallengeSwitcher} />
      </Provider>
    )
  }
}

export function mountCirclesAgriculture(node: HTMLElement) {
  ReactDOM.render(<Circles challenge="agriculture" />, node)
}
export function mountCirclesElectricity(node: HTMLElement) {
  ReactDOM.render(<Circles challenge="electricity" />, node)
}
export function mountCirclesBuildings(node: HTMLElement) {
  ReactDOM.render(<Circles challenge="buildings" />, node)
}
export function mountCirclesTransportation(node: HTMLElement) {
  ReactDOM.render(<Circles challenge="transportation" />, node)
}
export function mountCirclesManufacturing(node: HTMLElement) {
  ReactDOM.render(<Circles challenge="manufacturing" />, node)
}
export function mountCircles(node: HTMLElement) {
  ReactDOM.render(<Circles challenge="agriculture" showChallengeSwitcher />, node)
}
